import { Link } from 'react-router-dom'
import UnifiedRegisterForm from '../../components/auth/UnifiedRegisterForm'

export default function RegisterPage() {
  return (
    <div className="min-h-screen bg-slate-950 flex items-center justify-center p-4" data-testid="page-register">
      <div className="w-full max-w-md">
        <UnifiedRegisterForm />
        <p className="mt-4 text-center text-slate-500 text-sm">
          <Link to="/" className="text-emerald-500 hover:underline">
            ← Back to home
          </Link>
        </p>
      </div>
    </div>
  )
}
